import { Component, OnInit, Inject, Input, Output ,EventEmitter} from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from 'src/app/service/order.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { CheckoutComponent } from '../checkout/checkout.component';

@Component({
  selector: 'app-shopping',
  templateUrl: './shopping.component.html',
  styleUrls: ['./shopping.component.scss']
})
export class ShoppingComponent implements OnInit {
  terms: boolean = false;
  cards: any = []
  settings: any;
  user: any;
  totalPrice: any;
  @Input() article: any;
  @Output() event = new EventEmitter<any>();
  constructor(
    public dialogRef: MatDialogRef<ShoppingComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    public matDialog: MatDialog,
    private orderService: OrderService,
    private profileService: ProfileService
  ) {
  }

  minus() {
    if(this.article.quantity > 1){
      this.article.quantity = this.article.quantity - 1;
    }
    
    this.getTotalPrice();
  }

  plus() {
    this.article.quantity = this.article.quantity + 1;
    
    this.getTotalPrice();
  }

  getTotalPrice() {
    let total: number;
    total = parseFloat((parseFloat(this.article['price']) * parseFloat(this.article['quantity'])).toFixed(2));
    this.totalPrice = Math.round(total * 100)/100
  }

  checkout() {

    this.event.emit(true)
  }

  ngOnInit(): void {
    this.profileService.getUserProfile().subscribe((response: any) => {
      this.user = {
        firstname: response.payload.data().firstName,
        lastname: response.payload.data().lastName,
        address: response.payload.data().address,
        city: response.payload.data().city,
        company: response.payload.data().company,
        country: response.payload.data().country,
        email: response.payload.data().email,
        phone: response.payload.data().phone,
        zipcode: response.payload.data().zipcode,
      }
    })
    this.getTotalPrice();
  }
}
